import type { DescMessage, MessageShape } from '@bufbuild/protobuf';

export class GrpcOutput<T extends DescMessage> {
  constructor(public readonly message: MessageShape<T>) {}
}
